export default {
    title: 'Work spaces',
    new: 'New',
    all: 'View all',
    empty: {
        title: 'Looking for content?',
        content: 'Create a work space.',
        action: 'Create work space'
    }
}
